<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="
              () =>
                $router.push({
                  name: 'gestoesDeAulas',
                })
            "
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          {{ editing ? "Editando" : "Criando" }} Plano Bimestral
        </h1>
      </v-col>
    </v-row>
    <div v-if="turmaSemCircuito">
      <v-alert
        type="warning"
        border="left"
        colored-border
        elevation="2"
        icon="mdi-alert-circle-outline"
        dense
        class="mt-4"
      >
        Não é possível enviar planos bimestrais: não há circuito cadastrado para esta turma.
      </v-alert>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12" v-if="gestaoDeAula">
          <v-card color="green lighten-1" outlined>
            <v-col cols="8">
              <v-card-text>
                <h4 class="mb-2 d-flex align-center">
                  <span>Turma: {{ gestaoDeAula.turma?.descricao }}</span>
                  <v-chip
                    v-if="!turmaComSistemaBncc"
                    small
                    class="pa-3 ml-1 white--text"
                    color="teal darken-2"
                  >
                    <v-icon x-small class="mr-2">mdi mdi-information</v-icon>
                    Sistema BNCC não cadastrado.
                  </v-chip>
                </h4>

                <h4 class="mb-2">
                  Componente Curricular:
                  {{
                    gestaoDeAula.is_polivalencia === 1
                      ? gestaoDeAula.disciplina
                      : gestaoDeAula.disciplina.descricao
                  }}
                </h4>
                <h4 class="mb-2">
                  Professor:
                  {{ gestaoDeAula.professor ? gestaoDeAula.professor.nome : "[carregando...]" }}
                </h4>
              </v-card-text>
            </v-col>
            <v-col cols="12">
              <v-btn
                x-small
                class="ml-1 white--text"
                color="teal darken-2"
                @click="() => verHistoricoPlanos()"
              >
                <span>Histórico do lançamento de planos</span>
              </v-btn>
            </v-col>
            <v-col cols="12">
              <v-btn
                large
                class="ml-1 white--text"
                color="teal darken-4"
                @click="() => baixarDocumentoPlanoAnual()"
              >
                <v-icon class="mr-2">fa fa-download</v-icon>
                <span>Documento Auxiliar</span>
              </v-btn>
            </v-col>
          </v-card>
        </v-col>
        <v-col cols="12 text-center" class="pt-2">
          <template>
            <v-toolbar>
              <v-tabs dark background-color="primary" v-model="indexTabEtapas" grow>
                <v-tab
                  v-for="(value, desc) in etapas"
                  :key="parseInt(value, 10)"
                  @click="() => loadData(parseInt(value, 10))"
                >
                  <v-badge v-if="form.etapa_id === parseInt(value, 10)" color="success">
                    {{ desc }}
                  </v-badge>
                  <div v-else>{{ desc }}</div>
                </v-tab>
              </v-tabs>
            </v-toolbar>
          </template>
        </v-col>
      </v-row>
      <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
        <form
          @submit.prevent="handleSubmit(createOrUpdate)"
          v-if="loadPlano"
          :disabled="submittingForm"
        >
          <v-row>
            <v-col cols="12">
              <v-alert
                v-if="!disciplinaEspecial"
                color="green lighten-4"
                dense
                border="left"
                elevation="0"
                icon="mdi-alert-outline"
                class="mb-4"
              >
                <strong>Atenção:</strong>
                Os campos ({{ isSistemaBnccComputacao ? "Eixos" : "Unidades Temáticas" }}, Objetos
                do Conhecimento e Habilidades) são obrigatórios apenas para Componente(s)
                Curricular(es) integradas ao Sistema BNCC.
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      class="ml-2 align-self-center"
                      color="green darken-4"
                      dark
                      small
                      v-bind="attrs"
                      v-on="on"
                    >
                      mdi-information-outline
                    </v-icon>
                  </template>
                  <div style="max-width: 300px">
                    <strong>Componentes Curriculares integradas ao Sistema BNCC:</strong>
                    <ul>
                      <li>Português</li>
                      <li>Arte</li>
                      <li>Educação física</li>
                      <li>Inglês</li>
                      <li>Matemática</li>
                      <li>Ciências</li>
                      <li>Geografia</li>
                      <li>História</li>
                      <li>Ensino Religioso</li>
                      <li>Computação</li>
                    </ul>
                  </div>
                </v-tooltip>
              </v-alert>
            </v-col>

            <v-col cols="12" v-if="!disciplinaEspecial">
              <ValidationProvider name="Tematica" v-slot="{ errors }">
                <e-label>{{ isSistemaBnccComputacao ? "EIXO" : "UNIDADES TEMÁTICAS" }}</e-label>
                <v-chip
                  label
                  x-small
                  class="ml-2"
                  color="green lighten-4"
                  v-if="!disciplinaPertenceAoBncc"
                  >Não obrigatório</v-chip
                >

                <div class="d-flex flex-wrap">
                  <template v-if="unidadesTematicasSelecionadas.length">
                    <v-chip
                      v-for="(item, index) in unidadesTematicasSelecionadas"
                      :key="index"
                      label
                      large
                      color="secondary"
                      class="ma-1 chip-wrap"
                    >
                      {{ item }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip label large class="ma-1" color="grey lighten-2" text-color="black">
                      Selecione pelo menos uma habilidade para exibir
                      {{ isSistemaBnccComputacao ? "os eixos" : "as unidades temáticas" }}
                    </v-chip>
                  </template>
                </div>

                <span class="error--text text-caption">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" v-if="!disciplinaEspecial">
              <ValidationProvider name="Objeto do Conhecimento" v-slot="{ errors }">
                <e-label>OBJETOS DO CONHECIMENTO</e-label>
                <v-chip
                  label
                  x-small
                  class="ml-2"
                  color="green lighten-4"
                  v-if="!disciplinaPertenceAoBncc"
                  >Não obrigatório</v-chip
                >

                <div class="d-flex flex-wrap">
                  <template v-if="objetosConhecimentoSelecionados.length">
                    <v-chip
                      v-for="(obj, index) in objetosConhecimentoSelecionados"
                      :key="index"
                      label
                      large
                      color="primary"
                      class="ma-1 descricao-wrap"
                    >
                      {{ obj }}
                    </v-chip>
                  </template>
                  <template v-else>
                    <v-chip label large class="ma-1" color="grey lighten-2" text-color="black">
                      Selecione pelo menos uma habilidade para exibir os objetos do conhecimento
                    </v-chip>
                  </template>
                </div>

                <span class="error--text text-caption">{{ errors[0] }}</span>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" v-if="!disciplinaEspecial">
              <ValidationProvider
                name="Habilidades"
                :rules="disciplinaPertenceAoBncc ? 'required' : ''"
                v-slot="{ errors }"
              >
                <e-label>HABILIDADES</e-label>
                <v-chip
                  label
                  x-small
                  class="ml-2"
                  color="green lighten-4"
                  v-if="!disciplinaPertenceAoBncc"
                  >Não obrigatório</v-chip
                >
                <v-autocomplete
                  v-model="form.habilidades"
                  :items="habilidadesBncc"
                  item-text="descricao"
                  item-value="id"
                  multiple
                  chips
                  clearable
                  solo
                  dense
                  return-object
                  :error-messages="errors"
                  menu-props="max-height: 100"
                  style="max-height: 320px; overflow-y: auto; padding-right: 8px"
                  :filter="habilidadesSiglasFilter"
                  no-data-text="Nenhuma habilidade encontrada para esse Componente Curricular"
                >
                  <template v-slot:item="data">
                    <div class="d-flex flex-column align-start pa-4 w-100">
                      <v-chip small class="mb-1" color="primary" text-color="white">
                        {{ data.item.apelido }}
                      </v-chip>
                      <span class="descricao-wrap">
                        {{ data.item.descricao }}
                      </span>
                      <v-divider class="mx-4" />
                    </div>
                  </template>

                  <template v-slot:selection="data">
                    <v-row align="center" class="ma-4">
                      <v-col cols="auto">
                        <v-chip color="grey lighten-2" small class="mr-2" text-color="black">
                          {{ data.item.apelido }}
                        </v-chip>
                      </v-col>
                      <v-col cols="auto">
                        <span class="descricao-wrap">
                          {{ data.item.descricao }}
                        </span>
                      </v-col>
                    </v-row>
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" v-if="habilidadesSaeb && habilidadesSaeb.length">
              <ValidationProvider name="Descritores" rules="required" v-slot="{ errors }">
                <e-label>DESCRITORES</e-label>
                <v-autocomplete
                  v-model="form.descritores"
                  :items="habilidadesSaeb"
                  item-value="id"
                  item-text="descricao"
                  :filter="customFilter"
                  multiple
                  chips
                  clearable
                  solo
                  dense
                  menu-props="max-height: 100"
                  style="max-height: 320px; overflow-y: auto; padding-right: 8px"
                  :error-messages="errors"
                  no-data-text="Nenhum descritor encontrado"
                >
                  <template v-slot:item="{ item }">
                    <div class="d-flex flex-column pa-4">
                      <span class="font-weight-bold">{{ formatCode(item) }}</span>
                      <span class="descricao-wrap">{{ item.descricao }}</span>
                    </div>
                  </template>

                  <template v-slot:selection="{ item, index }">
                    <div class="ma-2">
                      <v-chip :key="index" small>
                        <span class="font-weight-bold">{{ formatCode(getItemById(item.id)) }}</span>
                        <span class="ml-1 d-none d-sm-inline">{{
                          getItemById(item.id).descricao
                        }}</span>
                      </v-chip>
                    </div>
                  </template>
                </v-autocomplete>
              </ValidationProvider>
            </v-col>

            <v-col cols="12" v-if="disciplinaEspecial">
              <ValidationProvider
                name="Unidades Temáticas Componente Curricular Especial"
                v-slot="{ errors }"
              >
                <e-label>UNIDADES TEMÁTICAS</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="form.unidades_tematicas_especial"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" v-if="disciplinaEspecial">
              <ValidationProvider
                name="Objetos do Conhecimento Componente Curricular Especial"
                v-slot="{ errors }"
              >
                <e-label>OBJETOS DO CONHECIMENTO</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="form.objetos_conhecimento_especial"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12" v-if="disciplinaEspecial">
              <ValidationProvider
                name="Habilidades Componente Curricular Especial"
                v-slot="{ errors }"
              >
                <e-label>HABILIDADES</e-label>
                <v-textarea
                  solo
                  dense
                  v-model="form.habilidades_especial"
                  :error-messages="errors"
                />
              </ValidationProvider>
            </v-col>

            <v-col cols="12">
              <ValidationProvider name="Metodologia" rules="required" v-slot="{ errors }">
                <e-label>PROCEDIMENTO METODOLÓGICO</e-label>
                <v-textarea solo dense v-model="form.metodologia" :error-messages="errors" />
              </ValidationProvider>
            </v-col>
            <v-col cols="12">
              <ValidationProvider
                name="Avaliação da aprendizagem"
                rules="required"
                v-slot="{ errors }"
              >
                <e-label>AVALIAÇÃO</e-label>

                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                    md="3"
                    v-for="(item, index) in $constants.planoBimestralAvalicao"
                    :key="index"
                  >
                    <v-checkbox
                      :label="item.label"
                      :value="item.label"
                      v-model="form.avaliacao_aprendizagem"
                      multiple
                      :error-messages="errors"
                    />
                  </v-col>
                </v-row>

                <!-- <span class="text-error text-caption" v-if="errors.length">{{ errors[0] }}</span> -->
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-col cols="12" class="mt-6">
            <v-row>
              <v-btn
                color="primary"
                :disabled="submittingForm"
                :loading="submittingForm"
                type="submit"
                >Enviar Dados</v-btn
              >
              <v-btn
                color="success"
                class="ml-3"
                @click="exportDialog = true"
                :disabled="!planoPreenchido"
                >Exportar plano</v-btn
              >
            </v-row>
          </v-col>
        </form>
        <v-row justify="center">
          <v-dialog v-model="exportDialog" persistent max-width="800px">
            <v-card>
              <v-card-title class="primary">
                <span style="color: #fff" class="text-h5">Exportar Plano</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-container>
                  <ValidationObserver v-slot="{ handleSubmit }">
                    <form
                      v-if="show"
                      @submit.prevent="handleSubmit(exportarPlano)"
                      :disabled="submittingForm"
                    >
                      <v-row>
                        <v-col class="pt-4 pb-0" cols="12">
                          <e-label class="font-weight-medium">Turma</e-label>
                          <p class="font-weight-regular">
                            <v-select
                              :items="turmas"
                              item-text="turma.descricao"
                              item-value="turma.id"
                              return-object
                              label="Selecione o campo abaixo"
                              v-model="turmaSelecionada"
                              @change="(item) => setGestao(item)"
                            ></v-select>
                          </p>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12">
                          <e-label class="font-weight-medium">PROCEDIMENTO METODOLÓGICO</e-label>
                          <p class="font-weight-regular">
                            {{ form.metodologia }}
                          </p>
                        </v-col>
                      </v-row>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          style="color: #fff"
                          class="red darken-1"
                          @click="exportDialog = false"
                        >
                          Fechar
                        </v-btn>
                        <v-btn
                          :disabled="submittingForm"
                          :loading="submittingForm"
                          type="submit"
                          style="color: #fff"
                          class="green darken-1"
                          >Salvar</v-btn
                        >
                      </v-card-actions>
                    </form>
                  </ValidationObserver>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-row>
      </ValidationObserver>
      <e-drawer-planos-lancados
        v-model="openDrawer"
        :gestao_id="parseInt($route.params.gestaoDeAulaId, 10)"
        :disciplina_id="parseInt($route.params.disciplinaId, 10)"
        :etapa="etapaSelecionada"
      />
    </div>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    gestaoDeAulaId: {
      type: [String, Number],
      require: true,
    },
  },

  async mounted() {
    await this.loadData();
  },
  data() {
    return {
      submittingForm: false,
      form: {
        etapa_id: null,
        avaliacao_aprendizagem: [],
        habilidades: [],
        descritores: [],
      },
      habilidades: [],
      descritores: [],
      openDrawer: false,
      gestaoDeAula: {
        turma: {
          descricao: "",
        },
        disciplina: {
          descricao: "",
        },
        disciplinas: [],
      },
      loadPlano: true,
      sistemaBnnc: null,
      habilidadesBncc: null,
      habilidadesSaeb: null,
      etapas: [],
      indexTabEtapas: null,
      exportDialog: false,
      show: true,
      turmas: [],
      turmaSelecionada: null,
      formExportarPlano: {
        etapa_id: 0,
      },
      disciplinaPertenceAoBncc: false,
      disciplinaEspecial: false,
      turmaComSistemaBncc: false,
    };
  },
  computed: {
    objetosConhecimentoSelecionados() {
      const todos = this.form.habilidades?.map((h) => h.objeto_conhecimento).filter(Boolean);
      return [...new Set(todos)];
    },
    unidadesTematicasSelecionadas() {
      const todas = this.form.habilidades
        ?.map((h) => h.eixo || h.unidades_tematicas || h.praticas_linguagem)
        .filter(Boolean);

      return [...new Set(todas)];
    },
    isSistemaBnccComputacao() {
      const descricoes = [
        this.sistemaBnnc?.descricao,
        ...(this.sistemaBnnc?.children ?? []).map((child) => child?.descricao),
      ];
      return descricoes.some((descricao) => (descricao || "").toLowerCase().includes("computa"));
    },
    turmaSemCircuito() {
      return this.etapas.length === 0;
    },
    planoPreenchido() {
      if (this.disciplinaPertenceAoBncc) {
        return (
          this.form.habilidades &&
          this.form.habilidades.length > 0 &&
          this.form.metodologia &&
          this.form.metodologia.trim().length > 0 &&
          this.form.avaliacao_aprendizagem &&
          this.form.avaliacao_aprendizagem.length > 0
        );
      }
      if (this.disciplinaEspecial) {
        return (
          this.form.metodologia &&
          this.form.metodologia.trim().length > 0 &&
          this.form.avaliacao_aprendizagem &&
          this.form.avaliacao_aprendizagem.length > 0
        );
      }
      return (
        this.form.metodologia &&
        this.form.metodologia.trim().length > 0 &&
        this.form.avaliacao_aprendizagem &&
        this.form.avaliacao_aprendizagem.length > 0
      );
    },
    etapaSelecionada() {
      const entry = Object.entries(this.etapas).find(([, val]) => val === this.form.etapa_id);
      if (!entry) return null;
      const [descricao, id] = entry;
      return { descricao, id };
    },
  },

  methods: {
    getItemById(id) {
      return this.habilidadesSaeb.find((item) => item.id === id) || {};
    },
    async verHistoricoPlanos() {
      this.openDrawer = !this.openDrawer;
    },
    async editarPlano(etapa_id) {
      this.loadPlano = false;
      this.$loaderService.open("Carregando dados...");
      try {
        const gestaoDeAulaId = this.$route.params.gestaoDeAulaId;

        const response = await this.$services.planosBimestraisService.planoBimestral(
          parseInt(gestaoDeAulaId, 10),
          parseInt(etapa_id, 10),
          parseInt(this.disciplinaId, 10)
        );

        if (response.plano !== "") {
          this.form = {
            ...response.plano,
            avaliacao_aprendizagem: response.plano.avaliacao_aprendizagem
              ? JSON.parse(response.plano.avaliacao_aprendizagem)
              : [],
            habilidades: response.plano.habilidades ? JSON.parse(response.plano.habilidades) : [],
            descritores: response.descritores_ids || [],
          };
        } else {
          this.form = {
            avaliacao_aprendizagem: [],
            habilidades: [],
            descritores: [],
          };
        }
        this.form.instrutorDisciplinaTurma_id = parseInt(gestaoDeAulaId, 10);
        this.form.disciplina_id = this.disciplinaId;
        this.form.etapa_id = etapa_id;

        await this.$services.planosBimestraisService.createOrUpdate(this.form);

        this.loadPlano = true;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async createOrUpdate() {
      this.$loaderService.open("Carregando dados...");
      try {
        const { gestaoDeAulaId } = this.$route.params;
        this.form.instrutorDisciplinaTurma_id = gestaoDeAulaId;
        this.form.disciplina_id = this.disciplinaId;
        await this.$services.planosBimestraisService.createOrUpdate(this.form);
        this.$toast.success("Plano bimestral salvo com sucesso!");
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async loadData(etapa_id) {
      if (this.$refs.observer) {
        await this.$refs.observer.reset();
      }
      this.submittingForm = false;
      const { gestaoDeAulaId } = this.$route.params;
      this.disciplinaId = parseInt(this.$route.params.disciplinaId, 10);

      try {
        this.$loaderService.open("Carregando dados...");
        if (etapa_id) {
          this.form.etapa_id = etapa_id;
        } else {
          this.gestaoDeAula = await this.$services.gestoesDeAulasService.visualizarTurmaGestao(
            gestaoDeAulaId
          );
          this.form.etapa_id = this.gestaoDeAula.turma.circuito?.etapas[0].id;
          const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
            this.gestaoDeAula
          );
          this.turmas = gestoes.filter((gestao) => gestao.turma.id !== this.gestaoDeAula.turma.id);
          if (this.gestaoDeAula.disciplinas.length > 0) {
            const disciplina = this.gestaoDeAula.disciplinas.filter((i) => {
              return i.id === this.disciplinaId;
            });
            this.gestaoDeAula.disciplina = disciplina[0].descricao;
          }

          if (this.gestaoDeAula.disciplinas.length > 0) {
            this.disciplinaPertenceAoBncc = this.gestaoDeAula.disciplinas?.find(
              (d) => d.id === this.disciplinaId
            )?.is_bncc;
            this.disciplinaEspecial = this.gestaoDeAula.disciplinas?.find(
              (d) => d.id === this.disciplinaId
            )?.is_especial;
          } else {
            this.disciplinaPertenceAoBncc = this.gestaoDeAula.disciplina.is_bncc;
            this.disciplinaEspecial = this.gestaoDeAula.disciplina.is_especial;
          }

          this.turmaComSistemaBncc = !!this.gestaoDeAula.turma.sistema_bncc_id;
        }

        const response = await this.$services.planosBimestraisService.planoBimestral(
          gestaoDeAulaId,
          this.form.etapa_id,
          this.disciplinaId
        );

        this.form.instrutorDisciplinaTurma_id = parseInt(gestaoDeAulaId, 10);
        this.sistemaBnnc = response.sistema_bncc;
        this.habilidadesBncc = response.habilidades_bncc;
        this.habilidadesSaeb = response.habilidades_saeb ?? [];
        this.etapas = response.etapas ?? [];

        if (response.plano !== "") {
          this.preencherPlano(response);
        } else {
          this.limparPlano();
        }

        this.$emit("dialogChange", !this.dialog);
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    preencherPlano(response) {
      this.form = {
        ...response.plano,
        avaliacao_aprendizagem: response.plano.avaliacao_aprendizagem
          ? JSON.parse(response.plano.avaliacao_aprendizagem)
          : [],
        habilidades: response.plano.habilidades ? JSON.parse(response.plano.habilidades) : [],
        descritores: response.descritores_ids || [],
      };
    },

    limparPlano() {
      this.form = {
        etapa_id: this.form.etapa_id,
        avaliacao_aprendizagem: [],
        habilidades: [],
        descritores: [],
      };
    },

    removeHabilidade(item) {
      this.form.habilidades = this.form.habilidades.filter((h) => h.id !== item.id);
    },
    habilidadesSiglasFilter(item, queryText, itemText) {
      const text = `${item.descricao} ${item.apelido}`.toLowerCase();
      return text.includes(queryText.toLowerCase());
    },
    formatCode(item) {
      try {
        const numero = parseInt(item.sequencia.split(".")[0], 10);
        return `${item.prefixo}${String(numero)}`;
      } catch {
        return item.prefixo + item.sequencia;
      }
    },

    customFilter(item, queryText) {
      const codigo = this.formatCode(item);
      const descricao = item.descricao?.toLowerCase() || "";

      return (
        codigo.toLowerCase().includes(queryText.toLowerCase()) ||
        descricao.includes(queryText.toLowerCase())
      );
    },

    async baixarDocumentoPlanoAnual() {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.planosBimestraisService.baixarDocumentoPlanoAnual(
          parseInt(this.$route.params.gestaoDeAulaId, 10),
          parseInt(this.form.etapa_id, 10),
          parseInt(this.$route.params.disciplinaId, 10)
        );
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },

    setGestao(item) {
      this.export_gestao = item.id;
    },
    async exportarPlano() {
      this.$loaderService.open("Exportando plano...");
      try {
        this.formExportarPlano.instrutorDisciplinaTurma_id = this.export_gestao;
        this.formExportarPlano.disciplina_id = this.gestaoDeAula.disciplina.id;
        this.formExportarPlano.etapa_id = this.form.etapa_id;

        this.formExportarPlano.habilidades = this.form.habilidades;
        this.formExportarPlano.descritores = this.form.descritores;

        this.formExportarPlano.avaliacao_aprendizagem = this.form.avaliacao_aprendizagem;
        this.formExportarPlano.metodologia = this.form.metodologia;

        await this.$services.planosBimestraisService.createOrUpdate(this.formExportarPlano);

        this.$toast.success("Plano exportado com sucesso!");

        this.dialog = false;
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style>
.descricao-wrap {
  white-space: normal;
  word-break: break-word;
}
</style>
